import { HttpClient } from '#client/http/index'
import {
  Profile,
  UserId,
  UpdateProfileParams,
  EmailDeliveryResponse,
  EmailDeliveryOptions,
  RequestEmailChangeParams,
} from '#client/resources/index'
import { ApiResponse } from '#client/resources/types'
import { depend } from '#client/utils/depend'
import snakecaseKeys from 'snakecase-keys'

export const me = async ({ httpClient }: { httpClient: HttpClient }) => {
  const { data }: ApiResponse<Profile> = await httpClient.get(
    '/user/profiles/me',
  )
  return data
}

export const update = depend(
  { transformParams: snakecaseKeys },
  async (
    { transformParams },
    { httpClient }: { httpClient: HttpClient },
    userId: UserId,
    params: UpdateProfileParams,
  ) => {
    return await httpClient.put(
      `/user/profiles/${userId}`,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      transformParams(params as { [key: string]: any }),
    )
  },
)

export const getEmailDeliveryOptions = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data }: ApiResponse<EmailDeliveryResponse> = await httpClient.get(
    '/user/profiles/deliveryMail',
  )

  // 各値の 0 | 1 をbooleanに変換する
  return Object.keys(data).reduce(
    (acc, key) => ({
      ...acc,
      [key]: data[key as keyof EmailDeliveryResponse] === 1 ? true : false,
    }),
    {},
  ) as EmailDeliveryOptions
}

export const updateEmailDeliveryOptions = async (
  { httpClient }: { httpClient: HttpClient },
  options: EmailDeliveryOptions,
) => {
  return await httpClient.put(
    '/user/profiles/deliveryMail',
    // 各値のbooleanを 0 | 1 に変換する
    Object.keys(options).reduce(
      (acc, key) => ({
        ...acc,
        [key]: options[key as keyof EmailDeliveryOptions] ? 1 : 0,
      }),
      {},
    ),
  )
}

export const requestEmailChange = async (
  { httpClient }: { httpClient: HttpClient },
  params: RequestEmailChangeParams,
) => {
  // このAPIはcamelCaseのキーで受け付けるため、snake_caseに変換しない
  return await httpClient.post('/user/profiles/email', params)
}

export const confirmEmailChange = async (
  { httpClient }: { httpClient: HttpClient },
  token: string,
) => {
  return await httpClient.put('/user/profiles/email/verify', { token })
}
